import { OrderAttributes } from "@albatrosdeveloper/ave-models-package";

export const ordersResponseMock: { valid: Partial<OrderAttributes & any>[], invalid: Partial<OrderAttributes & any>[] } = {
  "valid": [
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTime": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTime": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTime": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTimeSuggested": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTimeSuggested": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
  ],
  "invalid": [
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTime": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
    {
      "code": 955030,
      "type": {
        "_id": "66eb01db9a3c319653a134c4",
        "code": "DT002",
        "name": "PEDIDO",
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-18T16:37:47.156Z",
        "updatedAt": "2024-09-18T16:37:47.156Z",
        "__v": 0
      },
      "class": {
        "_id": "66edf01fcd7eece358c9d82b",
        "code": "PED-001",
        "name": "PEDIDO",
        "documentType": {
          "_id": "66eb01db9a3c319653a134c4",
          "code": "DT002",
          "name": "PEDIDO",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-20T21:58:55.869Z",
        "updatedAt": "2024-09-20T21:58:55.869Z",
        "__v": 0
      },
      "distributionChain": {
        "_id": "66e869683cb227f92b534ad3",
        "id": 1,
        "name": "CANAL DE DISTRIBUCION 1",
        "salesOrganization": {
          "_id": "66e61a21f19976d0ede01352",
          "id": 1,
          "name": "Cortijo",
          "statusId": 1
        },
        "channel": {
          "_id": "66e619820a9c9a43fc2d1f4e",
          "name": "CANAL VERDE",
          "code": 2,
          "statusId": 1
        },
        "company": 1,
        "statusId": 1
      },
      "salesOffice": {
        "_id": "66fc338fb3ff8be3db18ee05",
        "name": "CANAL 2",
        "externalKeys": {
          "code": "1000"
        },
        "type": "URBANO",
        "company": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          }
        ],
        "distributionchain": {
          "_id": "66e869683cb227f92b534ad3",
          "id": 1,
          "name": "CANAL DE DISTRIBUCION 1",
          "salesOrganization": {
            "_id": "66e61a21f19976d0ede01352",
            "id": 1,
            "name": "Cortijo",
            "statusId": 1
          },
          "channel": {
            "_id": "66e619820a9c9a43fc2d1f4e",
            "name": "CANAL VERDE",
            "code": 2,
            "statusId": 1
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 1,
            "name": "A&SSS",
            "statusId": 1
          },
          "statusId": 1
        },
        "distributionchaininherit": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "id": 1,
            "name": "CANAL DE DISTRIBUCION 1",
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "division": [
          {
            "_id": "66e61b7fd50e96a9ebdbabaa",
            "id": 1,
            "name": "Division 36",
            "statusId": 1
          }
        ],
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-10-01T17:38:23.336Z",
        "updatedAt": "2024-10-01T17:38:23.336Z",
        "id": 1,
        "__v": 0
      },
      "route": {
        "_id": "66e832aecd826187528bb91a",
        "id": 2,
        "externalKeys": "ashjhs",
        "name": "Rut Principal ",
        "company": {
          "_id": "66e61843ae5538d8b352411a",
          "id": 2,
          "name": "ABCD",
          "statusId": 1
        },
        "routegroup": {
          "_id": "66e831cdcd826187528bb90e",
          "id": "1",
          "name": "Grupo1",
          "statusId": 1
        },
        "routearea": {
          "_id": "66e8312810d7c8151bad6143",
          "id": "3",
          "name": "Ruta 3",
          "statusId": 1
        },
        "statusId": 1,
        "_deleted": false,
        "createdAt": "2024-09-16T13:29:18.872Z",
        "updatedAt": "2024-09-18T21:19:02.224Z",
        "__v": 0,
        "itinerary": [
          {
            "_id": "66eb4380c15eb18a6e11666e",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "RESERVA"
            ],
            "statusId": 1
          },
          {
            "_id": "66eb43c616a8ed5787ae8d18",
            "days": [
              "LUNES",
              "MARTES"
            ],
            "action": [
              "Prueba"
            ],
            "statusId": 1
          }
        ]
      },
      "subRoute": {
        "_id": "66ed969db86ac51e8e496f98",
        "name": "Sub Ruta 2",
        "company": {
          "_id": "66e616ede4297db7bf31d139",
          "id": 1,
          "name": "EL CORTIJO",
          "statusId": 1
        },
        "route": {
          "_id": "66e832aecd826187528bb91a",
          "id": "2",
          "name": "Rut Principal ",
          "statusId": 1
        },
        "deliverySubRoute": {
          "_id": "66e83500186bc8a08e24fbd4",
          "id": 3,
          "name": "Sub Ruta Secundaria ",
          "model": "Nuevo",
          "type": "Urbana",
          "statusId": 1
        },
        "model": "01",
        "type": "UR",
        "function": {
          "_id": "66ed9a5da5967f33f49d8245",
          "code": 2,
          "name": "PREVENTA 2",
          "statusId": 1
        },
        "useGps": false,
        "statusId": 1,
        "_deleted": false,
        "collaborators": [
          {
            "_id": "66ec7309a89157edc3b50279",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Socio de negocio",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66ec5c59128095e1d7ba77b1",
              "code": 3,
              "name": "funcion 1",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "670569ce47f468dcbc54b4ef",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          },
          {
            "_id": "67056b8c61cef156023e756f",
            "businessPartner": {
              "_id": "66ec82e7e1ff42630f312175",
              "id": 2,
              "name": "Pollos El Carbon",
              "statusId": 1
            },
            "businessPartnerFunction": {
              "_id": "66fc0cdc38a6fe8ed6e32d9d",
              "code": 6,
              "name": "Responsable de pago",
              "statusId": 1
            },
            "statusId": 1
          }
        ],
        "frequency": [
          {
            "_id": "66f6023621781d5ac9ba08f2",
            "days": [
              "Hoy tarde Mañana 8:30 Nicaragua"
            ],
            "businessPartners": [
              {
                "_id": "66eb59439937a6c62cd0a643",
                "position": 25,
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "schedule": {
                  "days": "MARTES",
                  "hourStart": "09:00",
                  "hourEnd": "20:00",
                  "minuteStart": 23,
                  "minuteEnd": 23,
                  "statusId": 1,
                  "_id": "66eb59439937a6c62cd0a644"
                }
              },
              {
                "_id": "66f5e9dd2a1ced27a5661fb1",
                "position": 2,
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Socio de negocio",
                  "statusId": 1
                },
                "schedule": {
                  "days": "LUNES,MARTES,MIERCOLES",
                  "hourStart": "08:00",
                  "hourEnd": "16:00",
                  "minuteStart": 20,
                  "minuteEnd": 25,
                  "statusId": 1,
                  "_id": "66f5e9dd2a1ced27a5661fb2"
                }
              }
            ],
            "statusId": 1
          }
        ],
        "orderDeliveryWindows": [],
        "itinerary": [
          {
            "_id": "66e37848a99edb11fab34381",
            "days": [
              1,
              2,
              3,
              4,
              5
            ],
            "action": [
              "IN_TRIP"
            ],
            "datetimeStart": "05:00",
            "datetimeEnd": "18:00",
            "statusId": 1
          },
          {
            "_id": "671147c5648f7ea1b2e1ec8a",
            "days": [
              1,
              2,
              3
            ],
            "action": [
              "CHARGE",
              "START_TRIP"
            ],
            "datetimeStart": "2024-10-17T17:19:17.761Z",
            "datetimeEnd": "2024-10-17T17:19:17.761Z",
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-20T15:37:01.909Z",
        "updatedAt": "2024-10-08T21:23:26.785Z",
        "id": 5,
        "__v": 0,
        "salesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "mainCollaborator": {
          "_id": "6705a2ce50808d3b8f1afad8",
          "businessPartner": {
            "_id": "66ec82e7e1ff42630f312175",
            "id": 2,
            "name": "Pollos El Carbon",
            "statusId": 1
          },
          "businessPartnerFunction": {
            "_id": "66fc0cdc38a6fe8ed6e32d9d",
            "code": 6,
            "name": "Responsable de pago",
            "statusId": 1
          },
          "userId": "66ec7309a89157edc3b50279",
          "statusId": 1
        }
      },
      "soldTo": {
        "_id": "66e8c82c19232ea0569fa3bc",
        "externalKeys": {
          "code": "1000059",
          "_id": "66e8c82c19232ea0569fa3bd"
        },
        "name": "La Mortadelaa",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72748a006680aa1f8ee4b",
            "code": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T21:50:49.276Z",
            "updatedAt": "2024-10-17T21:50:49.276Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 100,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 5,
            "name": "Sub Ruta 2",
            "statusId": 1
          }
        ],
        "contacts": [
          {
            "_id": "66e8cc28bb13469a176ee9f0",
            "fullName": "Ikser Marquez",
            "firstName": "Ikser",
            "lastName": "Marquez",
            "isOwnContact": false,
            "isPrincipal": true,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T00:24:08.760Z",
            "updatedAt": "2024-09-17T00:24:08.760Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          },
          {
            "_id": "66eb6b023a9c077cac588452",
            "isOwnContact": false,
            "isPrincipal": false,
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-19T00:06:26.731Z",
            "updatedAt": "2024-09-19T00:06:26.731Z",
            "emails": [],
            "addresses": [],
            "socialMedias": [],
            "phones": []
          }
        ],
        "distributionChains": [
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fc729cf1eecf415d146ab8",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "La Mortadela",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": "RP",
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              },
              {
                "_id": "66fc72e8f1eecf415d146abe",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": "EM",
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66ec6d60dbe26554ea957bd4",
            "name": "Cadena de distribucion 2",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a35f19976d0ede01356",
              "id": 2,
              "name": "Sala 4",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea1dc1eac64d3f7a3573f7",
                "id": 2,
                "name": "Division 37",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66e60b9e8210c1ff5998fcf3",
              "code": "24",
              "name": "Precio Normal",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66e60b548210c1ff5998fcee",
              "code": "23",
              "name": "Precio Descuento",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66ec743d6bac259507fabf98",
                "businessPartner": {
                  "_id": "66e8c82c19232ea0569fa3bc",
                  "id": 1,
                  "name": "Socio negocio 1",
                  "statusId": 1
                },
                "businessPartnerFunction": {
                  "_id": "66ec5c59128095e1d7ba77b1",
                  "code": 3,
                  "statusId": 1
                },
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [
          {
            "_id": "66eb7c1d04fec310afe30ada",
            "days": [
              "L-M-M"
            ],
            "hourStart": "8",
            "hourEnd": "17",
            "minutesStart": 10,
            "minutesEnd": 0,
            "statusId": 1
          }
        ],
        "createdAt": "2024-09-17T00:07:08.301Z",
        "updatedAt": "2024-10-17T21:50:49.276Z",
        "id": 1,
        "__v": 0,
        "NIT": "1001-12349-092",
        "position": 1,
        "emails": [
          {
            "_id": "66f5d1f1f3d985b616b87e1e",
            "email": "lamortadelar@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d218f3d985b616b87e21",
            "email": "agente01@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5d227f3d985b616b87e24",
            "email": "agente@hotmail.com",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "phones": [
          {
            "_id": "66f5dad58eff25aaaf761273",
            "phone": "97896534",
            "prefix": "504",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f5dae08eff25aaaf761276",
            "phone": "97896534",
            "prefix": "505",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f5daec8eff25aaaf761279",
            "phone": "97896564",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "address": {
          "_id": "66fb1e6059e3d0ea137536d5",
          "type": {
            "_id": "66e8b7baacd83d045b1bca47",
            "id": 1,
            "name": "Tipo 1",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-30T21:57:36.780Z",
            "updatedAt": "2024-09-30T21:57:36.780Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Kennedy",
          "locationOne": {
            "_id": "66e2552f8ef3202cd5d3e498",
            "code": "HN",
            "name": "Honduras",
            "statusId": 1
          },
          "locationTwo": {
            "_id": "66f5c1083a0b7fa4388dda83",
            "code": "IN",
            "name": "Intibucá",
            "statusId": 1
          },
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Esquina Opuesta",
          "reference": "Frente a Escuela Esteban Mendoza",
          "geolocationPoint": [
            123,
            12344
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-30T21:55:44.431Z",
          "updatedAt": "2024-09-30T21:57:36.780Z"
        },
        "creditAvailable": 100000,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "shipTo": {
        "_id": "66ec82e7e1ff42630f312175",
        "externalKeys": {
          "code": "string",
          "_id": "66ec82e7e1ff42630f312176"
        },
        "name": "Pollos El Carbon",
        "companies": [
          {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          }
        ],
        "types": [
          {
            "_id": "66e72754a006680aa1f8ee4f",
            "code": 2,
            "name": "Tipo 2",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-17T22:03:12.517Z",
            "updatedAt": "2024-10-17T22:03:12.517Z"
          }
        ],
        "businessPartnerGroup": {
          "_id": "66e726dea006680aa1f8ee47",
          "id": 1,
          "name": "Grupo socio negocios 1",
          "statusId": 1
        },
        "paymentCondition": {
          "_id": "66e8742321a48c1d389688b7",
          "id": 1002,
          "name": "Credito",
          "daysToPay": 30,
          "type": "CR",
          "statusId": 1
        },
        "creditLimitEnabled": true,
        "creditLimit": 10000,
        "allowOverdueInvoices": 1,
        "isTaxExempt": true,
        "routeArea": {
          "_id": "66e84a750e8615042f925239",
          "id": "1",
          "name": "ROUTE 1",
          "statusId": 1
        },
        "routingSalesOffice": {
          "_id": "66fc338fb3ff8be3db18ee05",
          "id": 1,
          "name": "CANAL 2",
          "statusId": 1
        },
        "useGps": true,
        "statusId": 1,
        "_deleted": false,
        "subRoutes": [
          {
            "_id": "66eaf84a6b38f170fbb2ab80",
            "id": 4,
            "name": "Colonia Miraflores",
            "statusId": 1
          }
        ],
        "contacts": [],
        "distributionChains": [
          {
            "_id": "66ea5440f017017d00d177dc",
            "name": "Nuevo Canal",
            "companyId": 2,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619090a9c9a43fc2d1f3c",
              "id": 1,
              "name": "CANAL A&SS23",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6604cd68efa0ba547b87",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          },
          {
            "_id": "66e869683cb227f92b534ad3",
            "name": "CANAL DE DISTRIBUCION 1",
            "companyId": 1,
            "salesOrganization": {
              "_id": "66e61a21f19976d0ede01352",
              "id": 1,
              "name": "Sala 1",
              "statusId": 1
            },
            "channel": {
              "_id": "66e619820a9c9a43fc2d1f4e",
              "id": 2,
              "name": "CANAL VERDE",
              "statusId": 1
            },
            "divisions": [
              {
                "_id": "66e61b7fd50e96a9ebdbabaa",
                "id": 1,
                "name": "Division 36",
                "statusId": 1
              }
            ],
            "ownPriceList": {
              "_id": "66ea4bef596928f8e70aed2b",
              "code": "TE1",
              "name": "Descuento TE",
              "statusId": 1
            },
            "ownDiscountList": {
              "_id": "66ea4ca62ecb7e7ca3a2c109",
              "code": "TE2",
              "name": "Descuento TE",
              "statusId": 1
            },
            "statusId": 1,
            "interlocutors": [
              {
                "_id": "66fd6d47995a04e7e9f7578f",
                "businessPartner": {
                  "_id": "66ec82e7e1ff42630f312175",
                  "id": 2,
                  "name": "Pollos El Carbon",
                  "statusId": 1
                },
                "businessPartnerFunctions": [
                  {
                    "_id": "66fc0cdc38a6fe8ed6e32d9d",
                    "code": 6,
                    "name": "Responsable de pago",
                    "statusId": 1
                  },
                  {
                    "_id": "66fc0cf838a6fe8ed6e32da0",
                    "code": 7,
                    "name": "Destinatario Mercancía",
                    "statusId": 1
                  }
                ],
                "statusId": 1
              }
            ]
          }
        ],
        "orderDeliveryWindows": [],
        "createdAt": "2024-09-19T20:00:39.369Z",
        "updatedAt": "2024-10-17T22:03:12.517Z",
        "id": 2,
        "__v": 0,
        "address": {
          "_id": "66f60ffa5a26356ed3928282",
          "type": {
            "_id": "66f5c1203a0b7fa4388dda8b",
            "name": "Yoro",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-27T01:52:58.551Z",
            "updatedAt": "2024-09-27T01:52:58.551Z",
            "type": {
              "_id": "6703775d81c90f7346bd29ce",
              "id": 2,
              "name": "Tipo 2",
              "type": "Urbana",
              "statusId": 1
            }
          },
          "name": "Colonia Palmira",
          "locationOne": null,
          "locationTwo": null,
          "locationThree": null,
          "locationFour": null,
          "locationFive": null,
          "locationSix": null,
          "address": "Colonia Palmira",
          "reference": "Esquina Opuesta",
          "geolocationPoint": [
            124210,
            9253253
          ],
          "isPrincipal": true,
          "statusId": 1,
          "_deleted": false,
          "createdAt": "2024-09-27T01:52:58.551Z",
          "updatedAt": "2024-09-27T01:52:58.551Z"
        },
        "phones": [
          {
            "_id": "66f6be7fae0fd506b0b37389",
            "phone": "95556654",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          },
          {
            "_id": "66f6be84ae0fd506b0b3738c",
            "phone": "95556644",
            "prefix": "504",
            "isPrincipal": false,
            "statusId": 1
          }
        ],
        "emails": [
          {
            "_id": "66f6bea9ae0fd506b0b3738f",
            "email": "juan@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          },
          {
            "_id": "66f6beb0ae0fd506b0b37392",
            "email": "juan23@hotmail.com",
            "isPrincipal": true,
            "statusId": 1
          }
        ],
        "NIT": "20901838784982-989",
        "position": 2,
        "ownDiscountList": {
          "_id": "66e60b548210c1ff5998fcee",
          "code": "23",
          "name": "Precio Descuento",
          "statusId": 1
        },
        "ownPriceList": {
          "_id": "66e60b9e8210c1ff5998fcf3",
          "code": "24",
          "name": "Precio Normal",
          "statusId": 1
        }
      },
      "trip": {
        "_id": "66eb01db9a3c319653a134c4",
        "id": 2,
        "dateHourStart": "2024-10-17T22:08:29.306Z",
        "dateHourEnd": "2024-10-17T22:08:29.306Z"
      },
      "isOrderTaxExempt": true,
      "totalTax": 0,
      "totalSurcharges": 0,
      "totalDiscount": 0,
      "total": 550,
      "deliveryDateTime": "2024-10-28T22:16:59.633Z",
      "loadDateTime": "2024-10-17T22:08:29.306Z",
      "creationDateTime": "2024-10-17T22:08:29.306Z",
      "status": "requested",
      "currency": {
        "_id": "66de46736be9008e63ecc023",
        "name": "Lempiras",
        "factor": 1
      },
      "company": {
        "_id": "66e616ede4297db7bf31d139",
        "id": 2,
        "name": "EL CORTIJO",
        "statusId": 1
      },
      "serial": "serial example",
      "detail": [
        {
          "_id": "670ea7889b4ad4c8d8a9283a",
          "code": "TAJ100",
          "name": "Tajo de Cerdo",
          "externalKeys": {
            "code": "TAJOP",
            "_id": "670ea7889b4ad4c8d8a9283b"
          },
          "company": {
            "_id": "66e616ede4297db7bf31d139",
            "id": 10,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66ea4bcf596928f8e70aed28",
            "code": "Lbs",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T17:34:00.097Z",
            "updatedAt": "2024-10-15T17:34:00.097Z"
          },
          "price": 100,
          "UMPActive": true,
          "materialBrand": {
            "_id": "670d23399b4ad4c8d8a922d6",
            "code": "TRMA",
            "name": "ASRW",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 201,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670eb28101844b3e4e5547e4",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:56:03.437Z",
                "updatedAt": "2024-10-16T18:56:03.437Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670eb2b99b4ad4c8d8a92886",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:26:09.190Z",
                "updatedAt": "2024-10-15T21:26:09.190Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ec5519b4ad4c8d8a928dc",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T18:58:32.114Z",
                "updatedAt": "2024-10-16T18:58:32.114Z"
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [
            {
              "_id": "671038749b4ad4c8d8a92d54",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "23",
              "minutesStart": 99,
              "minutesEnd": 20,
              "statusId": 0
            },
            {
              "_id": "6710860c1dce84d9e0897e43",
              "days": [
                "LUNES",
                "MARTES",
                "MIÉRCOLES"
              ],
              "hourStart": "12",
              "hourEnd": "12",
              "minutesStart": 50,
              "minutesEnd": 60,
              "statusId": 0
            }
          ],
          "createdAt": "2024-10-15T17:34:00.097Z",
          "updatedAt": "2024-10-17T03:35:50.320Z",
          "__v": 0,
          "subtotal": 500,
          "quantity": 5,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ea7889b4ad4c8d8a9283a",
              "code": "TAJ100",
              "name": "Tajo de Cerdo",
              "externalKeys": {
                "code": "TAJOP",
                "_id": "670ea7889b4ad4c8d8a9283b"
              },
              "company": {
                "_id": "66e616ede4297db7bf31d139",
                "id": 10,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T17:34:00.097Z",
                "updatedAt": "2024-10-15T17:34:00.097Z"
              },
              "price": 100,
              "UMPActive": true,
              "materialBrand": {
                "_id": "670d23399b4ad4c8d8a922d6",
                "code": "TRMA",
                "name": "ASRW",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 201,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670eb28101844b3e4e5547e4",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:56:03.437Z",
                    "updatedAt": "2024-10-16T18:56:03.437Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670eb2b99b4ad4c8d8a92886",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:26:09.190Z",
                    "updatedAt": "2024-10-15T21:26:09.190Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ec5519b4ad4c8d8a928dc",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T18:58:32.114Z",
                    "updatedAt": "2024-10-16T18:58:32.114Z"
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [
                {
                  "_id": "671038749b4ad4c8d8a92d54",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "23",
                  "minutesStart": 99,
                  "minutesEnd": 20,
                  "statusId": 0
                },
                {
                  "_id": "6710860c1dce84d9e0897e43",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIÉRCOLES"
                  ],
                  "hourStart": "12",
                  "hourEnd": "12",
                  "minutesStart": 50,
                  "minutesEnd": 60,
                  "statusId": 0
                }
              ],
              "createdAt": "2024-10-15T17:34:00.097Z",
              "updatedAt": "2024-10-17T03:35:50.320Z",
              "__v": 0,
              "subtotal": 500,
              "quantity": 5
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 5,
            "bonifications": [
              {
                "material": {
                  "_id": "670ea7889b4ad4c8d8a9283a",
                  "code": "TAJ100",
                  "name": "Tajo de Cerdo",
                  "externalKeys": {
                    "code": "TAJOP",
                    "_id": "670ea7889b4ad4c8d8a9283b"
                  },
                  "company": {
                    "_id": "66e616ede4297db7bf31d139",
                    "id": 10,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T17:34:00.097Z",
                    "updatedAt": "2024-10-15T17:34:00.097Z"
                  },
                  "price": 100,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "670d23399b4ad4c8d8a922d6",
                    "code": "TRMA",
                    "name": "ASRW",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 201,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670eb28101844b3e4e5547e4",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:56:03.437Z",
                        "updatedAt": "2024-10-16T18:56:03.437Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670eb2b99b4ad4c8d8a92886",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-15T21:26:09.190Z",
                        "updatedAt": "2024-10-15T21:26:09.190Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ec5519b4ad4c8d8a928dc",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false,
                        "createdAt": "2024-10-16T18:58:32.114Z",
                        "updatedAt": "2024-10-16T18:58:32.114Z"
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [
                    {
                      "_id": "671038749b4ad4c8d8a92d54",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "23",
                      "minutesStart": 99,
                      "minutesEnd": 20,
                      "statusId": 0
                    },
                    {
                      "_id": "6710860c1dce84d9e0897e43",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIÉRCOLES"
                      ],
                      "hourStart": "12",
                      "hourEnd": "12",
                      "minutesStart": 50,
                      "minutesEnd": 60,
                      "statusId": 0
                    }
                  ],
                  "createdAt": "2024-10-15T17:34:00.097Z",
                  "updatedAt": "2024-10-17T03:35:50.320Z",
                  "__v": 0,
                  "subtotal": 500,
                  "quantity": 5
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 5,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 100,
          "unitPriceOriginal": 100,
          "originalQuantity": 5,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ea7889b4ad4c8d8a9283a",
            "code": "TAJ100",
            "externalKeys": {
              "code": "TAJOP",
              "_id": "670ea7889b4ad4c8d8a9283b"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Tajo de Cerdo"
          }
        },
        {
          "_id": "670f348a9b4ad4c8d8a92b2e",
          "code": "RES200",
          "name": "RES",
          "externalKeys": {
            "code": "RES2000",
            "_id": "670f348a9b4ad4c8d8a92b2f"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa2caac6881544177229",
            "code": "456AA",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:35:38.613Z",
            "updatedAt": "2024-10-16T03:35:38.613Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 108,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670f348b9b4ad4c8d8a92b33",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:35:38.614Z",
          "updatedAt": "2024-10-16T20:28:08.356Z",
          "__v": 0,
          "subtotal": 400,
          "quantity": 2,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f348a9b4ad4c8d8a92b2e",
              "code": "RES200",
              "name": "RES",
              "externalKeys": {
                "code": "RES2000",
                "_id": "670f348a9b4ad4c8d8a92b2f"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:35:38.613Z",
                "updatedAt": "2024-10-16T03:35:38.613Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 108,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670f348b9b4ad4c8d8a92b33",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:35:38.614Z",
              "updatedAt": "2024-10-16T20:28:08.356Z",
              "__v": 0,
              "subtotal": 400,
              "quantity": 2
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 2,
            "bonifications": [
              {
                "material": {
                  "_id": "670f348a9b4ad4c8d8a92b2e",
                  "code": "RES200",
                  "name": "RES",
                  "externalKeys": {
                    "code": "RES2000",
                    "_id": "670f348a9b4ad4c8d8a92b2f"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:35:38.613Z",
                    "updatedAt": "2024-10-16T03:35:38.613Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 108,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670f348b9b4ad4c8d8a92b33",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa5faac688154417722f",
                        "code": "Kg",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:35:38.614Z",
                  "updatedAt": "2024-10-16T20:28:08.356Z",
                  "__v": 0,
                  "subtotal": 400,
                  "quantity": 2
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 2,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 2,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f348a9b4ad4c8d8a92b2e",
            "code": "RES200",
            "externalKeys": {
              "code": "RES2000",
              "_id": "670f348a9b4ad4c8d8a92b2f"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "RES"
          }
        },
        {
          "_id": "670f34eb9b4ad4c8d8a92b3b",
          "code": "ALU203",
          "name": "Aluzinc",
          "externalKeys": {
            "code": "ALU",
            "_id": "670f34eb9b4ad4c8d8a92b3c"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-16T03:37:15.887Z",
            "updatedAt": "2024-10-16T03:37:15.887Z"
          },
          "price": 200,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita2",
              "statusId": 1
            }
          ],
          "position": 9,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [
            {
              "_id": "670fde0a9b4ad4c8d8a92b9c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffe499b4ad4c8d8a92c00",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 1,
              "equivalentQuantity": 1,
              "conversionFactor": 1
            },
            {
              "_id": "670ffea89b4ad4c8d8a92c0b",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa2caac6881544177229",
                "code": "456AA",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 4,
              "equivalentQuantity": 3,
              "conversionFactor": 3
            }
          ],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-16T03:37:15.887Z",
          "updatedAt": "2024-10-16T17:58:00.443Z",
          "__v": 0,
          "subtotal": 600,
          "quantity": 3,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670f34eb9b4ad4c8d8a92b3b",
              "code": "ALU203",
              "name": "Aluzinc",
              "externalKeys": {
                "code": "ALU",
                "_id": "670f34eb9b4ad4c8d8a92b3c"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-16T03:37:15.887Z",
                "updatedAt": "2024-10-16T03:37:15.887Z"
              },
              "price": 200,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita2",
                  "statusId": 1
                }
              ],
              "position": 9,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [
                {
                  "_id": "670fde0a9b4ad4c8d8a92b9c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffe499b4ad4c8d8a92c00",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 1,
                  "equivalentQuantity": 1,
                  "conversionFactor": 1
                },
                {
                  "_id": "670ffea89b4ad4c8d8a92c0b",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa2caac6881544177229",
                    "code": "456AA",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 4,
                  "equivalentQuantity": 3,
                  "conversionFactor": 3
                }
              ],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-16T03:37:15.887Z",
              "updatedAt": "2024-10-16T17:58:00.443Z",
              "__v": 0,
              "subtotal": 600,
              "quantity": 3
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 3,
            "bonifications": [
              {
                "material": {
                  "_id": "670f34eb9b4ad4c8d8a92b3b",
                  "code": "ALU203",
                  "name": "Aluzinc",
                  "externalKeys": {
                    "code": "ALU",
                    "_id": "670f34eb9b4ad4c8d8a92b3c"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-16T03:37:15.887Z",
                    "updatedAt": "2024-10-16T03:37:15.887Z"
                  },
                  "price": 200,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita2",
                      "statusId": 1
                    }
                  ],
                  "position": 9,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "670fde0a9b4ad4c8d8a92b9c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffe499b4ad4c8d8a92c00",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa14aac6881544177225",
                        "code": "456A",
                        "name": "Libras",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 1,
                      "equivalentQuantity": 1,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670ffea89b4ad4c8d8a92c0b",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa2caac6881544177229",
                        "code": "456AA",
                        "name": "Kilogramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 4,
                      "equivalentQuantity": 3,
                      "conversionFactor": 3
                    }
                  ],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-16T03:37:15.887Z",
                  "updatedAt": "2024-10-16T17:58:00.443Z",
                  "__v": 0,
                  "subtotal": 600,
                  "quantity": 3
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 3,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 200,
          "unitPriceOriginal": 200,
          "originalQuantity": 3,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670f34eb9b4ad4c8d8a92b3b",
            "code": "ALU203",
            "externalKeys": {
              "code": "ALU",
              "_id": "670f34eb9b4ad4c8d8a92b3c"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita2",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Aluzinc"
          }
        },
        {
          "_id": "66ea000566e95efcfedf3f6f",
          "code": "20000003",
          "name": "Nuevo Material",
          "externalKeys": {
            "code": "aabs",
            "_id": "66ea000566e95efcfedf3f70"
          },
          "descriptionShort": "NM",
          "descriptionLong": "NM_45",
          "company": {
            "_id": "66ed969db86ac51e8e496f98",
            "id": 2,
            "name": "UYUSTOOLS PERU",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-09-17T22:17:41.181Z",
            "updatedAt": "2024-09-17T22:17:41.181Z"
          },
          "price": 45,
          "UMPActive": true,
          "materialBrand": {
            "_id": "66e9bdd2ac0ef2ffcfc17a60",
            "code": "ER34",
            "name": "Truper",
            "statusId": 1
          },
          "ltsLbs": 1,
          "barcodeType": "45T",
          "barcode": "YUUAYYDAS",
          "division": {
            "_id": "66ea5282f017017d00d177c5",
            "id": 4,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "66e9c033217b8ff54dfb8a1d",
              "code": "456A",
              "name": "Makita",
              "statusId": 1
            }
          ],
          "position": 1,
          "batchControlActive": true,
          "statusId": 1,
          "_deleted": false,
          "orderDeliveryWindows": [
            {
              "_id": "66ea23797e24bcf157f88778",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "66ea23d078e1c099e55be72f",
              "days": [
                "LUNES",
                "MARTES",
                "MIERCOLES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 1
            },
            {
              "_id": "6705ac129b4ad4c8d8a91f72",
              "days": [
                "L",
                "M"
              ],
              "hourStart": "10",
              "hourEnd": "11",
              "minutesStart": 0,
              "minutesEnd": 10,
              "statusId": 0
            },
            {
              "_id": "671035009b4ad4c8d8a92d25",
              "days": [
                "LUNES",
                "MARTES"
              ],
              "hourStart": "10 AM",
              "hourEnd": "12 PM",
              "minutesStart": 23,
              "minutesEnd": 5,
              "statusId": 0
            },
            {
              "_id": "671086451dce84d9e0897e4a",
              "days": [
                "MARTES"
              ],
              "hourStart": "08:00",
              "hourEnd": "17:00",
              "minutesStart": 60,
              "minutesEnd": 60,
              "statusId": 1
            }
          ],
          "createdAt": "2024-09-17T22:17:41.182Z",
          "updatedAt": "2024-10-17T03:36:37.831Z",
          "__v": 0,
          "dimensions": {
            "_id": "66ea14cb18ce978531e87dec",
            "height": 25,
            "width": 34,
            "length": 22,
            "grossWeight": 12,
            "netWeight": 23,
            "weightUnitOfMeasureCode": "Libras",
            "volume": 34,
            "volumeUnitOfMeasureCode": "Litros"
          },
          "tax": {
            "_id": "6705ac519b4ad4c8d8a91f75",
            "name": "ISV",
            "percentage": 15,
            "statusId": 1
          },
          "alternalUnitOfMeasures": [
            {
              "_id": "66f6cce8c88d668d2c01a24c",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66ea4bcf596928f8e70aed28",
                "code": "Lbs",
                "name": "LBS",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 24,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e329b4ad4c8d8a92696",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 25,
              "equivalentQuantity": 20,
              "conversionFactor": 1
            },
            {
              "_id": "670e6e669b4ad4c8d8a926a1",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 100,
              "equivalentQuantity": 1000,
              "conversionFactor": 1
            },
            {
              "_id": "670e70809b4ad4c8d8a926ac",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 2,
              "equivalentQuantity": 3,
              "conversionFactor": 2
            },
            {
              "_id": "670e71ae9b4ad4c8d8a926b7",
              "isUMP": true,
              "unitOfMeasure": {
                "_id": "66e9fa4aaac688154417722c",
                "code": "456AAC",
                "name": "Miligramos",
                "statusId": 1,
                "_deleted": false
              },
              "quantity": 3,
              "equivalentQuantity": 3,
              "conversionFactor": 4
            }
          ],
          "subtotal": 270,
          "quantity": 6,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "66ea000566e95efcfedf3f6f",
              "code": "20000003",
              "name": "Nuevo Material",
              "externalKeys": {
                "code": "aabs",
                "_id": "66ea000566e95efcfedf3f70"
              },
              "descriptionShort": "NM",
              "descriptionLong": "NM_45",
              "company": {
                "_id": "66ed969db86ac51e8e496f98",
                "id": 2,
                "name": "UYUSTOOLS PERU",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa5faac688154417722f",
                "code": "Kg",
                "name": "Kilogramos",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-09-17T22:17:41.181Z",
                "updatedAt": "2024-09-17T22:17:41.181Z"
              },
              "price": 45,
              "UMPActive": true,
              "materialBrand": {
                "_id": "66e9bdd2ac0ef2ffcfc17a60",
                "code": "ER34",
                "name": "Truper",
                "statusId": 1
              },
              "ltsLbs": 1,
              "barcodeType": "45T",
              "barcode": "YUUAYYDAS",
              "division": {
                "_id": "66ea5282f017017d00d177c5",
                "id": 4,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "66e9c033217b8ff54dfb8a1d",
                  "code": "456A",
                  "name": "Makita",
                  "statusId": 1
                }
              ],
              "position": 1,
              "batchControlActive": true,
              "statusId": 1,
              "_deleted": false,
              "orderDeliveryWindows": [
                {
                  "_id": "66ea23797e24bcf157f88778",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "66ea23d078e1c099e55be72f",
                  "days": [
                    "LUNES",
                    "MARTES",
                    "MIERCOLES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 1
                },
                {
                  "_id": "6705ac129b4ad4c8d8a91f72",
                  "days": [
                    "L",
                    "M"
                  ],
                  "hourStart": "10",
                  "hourEnd": "11",
                  "minutesStart": 0,
                  "minutesEnd": 10,
                  "statusId": 0
                },
                {
                  "_id": "671035009b4ad4c8d8a92d25",
                  "days": [
                    "LUNES",
                    "MARTES"
                  ],
                  "hourStart": "10 AM",
                  "hourEnd": "12 PM",
                  "minutesStart": 23,
                  "minutesEnd": 5,
                  "statusId": 0
                },
                {
                  "_id": "671086451dce84d9e0897e4a",
                  "days": [
                    "MARTES"
                  ],
                  "hourStart": "08:00",
                  "hourEnd": "17:00",
                  "minutesStart": 60,
                  "minutesEnd": 60,
                  "statusId": 1
                }
              ],
              "createdAt": "2024-09-17T22:17:41.182Z",
              "updatedAt": "2024-10-17T03:36:37.831Z",
              "__v": 0,
              "dimensions": {
                "_id": "66ea14cb18ce978531e87dec",
                "height": 25,
                "width": 34,
                "length": 22,
                "grossWeight": 12,
                "netWeight": 23,
                "weightUnitOfMeasureCode": "Libras",
                "volume": 34,
                "volumeUnitOfMeasureCode": "Litros"
              },
              "tax": {
                "_id": "6705ac519b4ad4c8d8a91f75",
                "name": "ISV",
                "percentage": 15,
                "statusId": 1
              },
              "alternalUnitOfMeasures": [
                {
                  "_id": "66f6cce8c88d668d2c01a24c",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66ea4bcf596928f8e70aed28",
                    "code": "Lbs",
                    "name": "LBS",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 24,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e329b4ad4c8d8a92696",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 25,
                  "equivalentQuantity": 20,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e6e669b4ad4c8d8a926a1",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 100,
                  "equivalentQuantity": 1000,
                  "conversionFactor": 1
                },
                {
                  "_id": "670e70809b4ad4c8d8a926ac",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 2,
                  "equivalentQuantity": 3,
                  "conversionFactor": 2
                },
                {
                  "_id": "670e71ae9b4ad4c8d8a926b7",
                  "isUMP": true,
                  "unitOfMeasure": {
                    "_id": "66e9fa4aaac688154417722c",
                    "code": "456AAC",
                    "name": "Miligramos",
                    "statusId": 1,
                    "_deleted": false
                  },
                  "quantity": 3,
                  "equivalentQuantity": 3,
                  "conversionFactor": 4
                }
              ],
              "subtotal": 270,
              "quantity": 6
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 6,
            "bonifications": [
              {
                "material": {
                  "_id": "66ea000566e95efcfedf3f6f",
                  "code": "20000003",
                  "name": "Nuevo Material",
                  "externalKeys": {
                    "code": "aabs",
                    "_id": "66ea000566e95efcfedf3f70"
                  },
                  "descriptionShort": "NM",
                  "descriptionLong": "NM_45",
                  "company": {
                    "_id": "66ed969db86ac51e8e496f98",
                    "id": 2,
                    "name": "UYUSTOOLS PERU",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa5faac688154417722f",
                    "code": "Kg",
                    "name": "Kilogramos",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-09-17T22:17:41.181Z",
                    "updatedAt": "2024-09-17T22:17:41.181Z"
                  },
                  "price": 45,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "66e9bdd2ac0ef2ffcfc17a60",
                    "code": "ER34",
                    "name": "Truper",
                    "statusId": 1
                  },
                  "ltsLbs": 1,
                  "barcodeType": "45T",
                  "barcode": "YUUAYYDAS",
                  "division": {
                    "_id": "66ea5282f017017d00d177c5",
                    "id": 4,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "66e9c033217b8ff54dfb8a1d",
                      "code": "456A",
                      "name": "Makita",
                      "statusId": 1
                    }
                  ],
                  "position": 1,
                  "batchControlActive": true,
                  "statusId": 1,
                  "_deleted": false,
                  "orderDeliveryWindows": [
                    {
                      "_id": "66ea23797e24bcf157f88778",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "66ea23d078e1c099e55be72f",
                      "days": [
                        "LUNES",
                        "MARTES",
                        "MIERCOLES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 1
                    },
                    {
                      "_id": "6705ac129b4ad4c8d8a91f72",
                      "days": [
                        "L",
                        "M"
                      ],
                      "hourStart": "10",
                      "hourEnd": "11",
                      "minutesStart": 0,
                      "minutesEnd": 10,
                      "statusId": 0
                    },
                    {
                      "_id": "671035009b4ad4c8d8a92d25",
                      "days": [
                        "LUNES",
                        "MARTES"
                      ],
                      "hourStart": "10 AM",
                      "hourEnd": "12 PM",
                      "minutesStart": 23,
                      "minutesEnd": 5,
                      "statusId": 0
                    },
                    {
                      "_id": "671086451dce84d9e0897e4a",
                      "days": [
                        "MARTES"
                      ],
                      "hourStart": "08:00",
                      "hourEnd": "17:00",
                      "minutesStart": 60,
                      "minutesEnd": 60,
                      "statusId": 1
                    }
                  ],
                  "createdAt": "2024-09-17T22:17:41.182Z",
                  "updatedAt": "2024-10-17T03:36:37.831Z",
                  "__v": 0,
                  "dimensions": {
                    "_id": "66ea14cb18ce978531e87dec",
                    "height": 25,
                    "width": 34,
                    "length": 22,
                    "grossWeight": 12,
                    "netWeight": 23,
                    "weightUnitOfMeasureCode": "Libras",
                    "volume": 34,
                    "volumeUnitOfMeasureCode": "Litros"
                  },
                  "tax": {
                    "_id": "6705ac519b4ad4c8d8a91f75",
                    "name": "ISV",
                    "percentage": 15,
                    "statusId": 1
                  },
                  "alternalUnitOfMeasures": [
                    {
                      "_id": "66f6cce8c88d668d2c01a24c",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66ea4bcf596928f8e70aed28",
                        "code": "Lbs",
                        "name": "LBS",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 24,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e329b4ad4c8d8a92696",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 25,
                      "equivalentQuantity": 20,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e6e669b4ad4c8d8a926a1",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 100,
                      "equivalentQuantity": 1000,
                      "conversionFactor": 1
                    },
                    {
                      "_id": "670e70809b4ad4c8d8a926ac",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 2,
                      "equivalentQuantity": 3,
                      "conversionFactor": 2
                    },
                    {
                      "_id": "670e71ae9b4ad4c8d8a926b7",
                      "isUMP": true,
                      "unitOfMeasure": {
                        "_id": "66e9fa4aaac688154417722c",
                        "code": "456AAC",
                        "name": "Miligramos",
                        "statusId": 1,
                        "_deleted": false
                      },
                      "quantity": 3,
                      "equivalentQuantity": 3,
                      "conversionFactor": 4
                    }
                  ],
                  "subtotal": 270,
                  "quantity": 6
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 6,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 45,
          "unitPriceOriginal": 45,
          "originalQuantity": 6,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "66ea000566e95efcfedf3f6f",
            "code": "20000003",
            "externalKeys": {
              "code": "aabs",
              "_id": "66ea000566e95efcfedf3f70"
            },
            "materialGroups": [
              {
                "_id": "66e9c033217b8ff54dfb8a1d",
                "code": "456A",
                "name": "Makita",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Nuevo Material"
          }
        },
        {
          "_id": "670ee1de9b4ad4c8d8a929b2",
          "code": "1234",
          "name": "Salmon",
          "externalKeys": {
            "code": "1234Q",
            "_id": "670ee1de9b4ad4c8d8a929b3"
          },
          "company": {
            "_id": "670ebaa456795645a556a2b5",
            "id": 1,
            "name": "EL CORTIJO",
            "statusId": 1
          },
          "baseUnitOfMeasure": {
            "_id": "66e9fa14aac6881544177225",
            "code": "456A",
            "name": "Libras",
            "statusId": 1,
            "_deleted": false,
            "createdAt": "2024-10-15T21:42:54.328Z",
            "updatedAt": "2024-10-15T21:42:54.328Z"
          },
          "price": 5,
          "UMPActive": true,
          "materialBrand": {
            "_id": "67093bff9b4ad4c8d8a9220f",
            "code": "PL",
            "name": "Market Cortijo",
            "statusId": 1
          },
          "ltsLbs": 0,
          "division": {
            "_id": "66ea523af017017d00d177c0",
            "id": 3,
            "name": "Division 10",
            "statusId": 1
          },
          "materialGroups": [
            {
              "_id": "670d4ac19b4ad4c8d8a92391",
              "code": "CL",
              "name": "Clavos",
              "statusId": 1
            }
          ],
          "position": 202,
          "batchControlActive": false,
          "statusId": 1,
          "_deleted": false,
          "alternalUnitOfMeasures": [],
          "orderDeliveryWindows": [],
          "createdAt": "2024-10-15T21:42:54.328Z",
          "updatedAt": "2024-10-16T20:28:29.765Z",
          "__v": 0,
          "subtotal": 40,
          "quantity": 8,
          "status": "requested",
          "note": "Some note",
          "totalTax": 0,
          "totalSurcharges": 0,
          "totalDiscount": 0,
          "promotionData": {
            "code": "promo_code",
            "companyId": 2,
            "material": {
              "_id": "670ee1de9b4ad4c8d8a929b2",
              "code": "1234",
              "name": "Salmon",
              "externalKeys": {
                "code": "1234Q",
                "_id": "670ee1de9b4ad4c8d8a929b3"
              },
              "company": {
                "_id": "670ebaa456795645a556a2b5",
                "id": 1,
                "name": "EL CORTIJO",
                "statusId": 1
              },
              "baseUnitOfMeasure": {
                "_id": "66e9fa14aac6881544177225",
                "code": "456A",
                "name": "Libras",
                "statusId": 1,
                "_deleted": false,
                "createdAt": "2024-10-15T21:42:54.328Z",
                "updatedAt": "2024-10-15T21:42:54.328Z"
              },
              "price": 5,
              "UMPActive": true,
              "materialBrand": {
                "_id": "67093bff9b4ad4c8d8a9220f",
                "code": "PL",
                "name": "Market Cortijo",
                "statusId": 1
              },
              "ltsLbs": 0,
              "division": {
                "_id": "66ea523af017017d00d177c0",
                "id": 3,
                "name": "Division 10",
                "statusId": 1
              },
              "materialGroups": [
                {
                  "_id": "670d4ac19b4ad4c8d8a92391",
                  "code": "CL",
                  "name": "Clavos",
                  "statusId": 1
                }
              ],
              "position": 202,
              "batchControlActive": false,
              "statusId": 1,
              "_deleted": false,
              "alternalUnitOfMeasures": [],
              "orderDeliveryWindows": [],
              "createdAt": "2024-10-15T21:42:54.328Z",
              "updatedAt": "2024-10-16T20:28:29.765Z",
              "__v": 0,
              "subtotal": 40,
              "quantity": 8
            },
            "unitOfMeasure": {
              "_id": "66e9fa14aac6881544177225",
              "code": "456A",
              "name": "Libras"
            },
            "quantity": 8,
            "bonifications": [
              {
                "material": {
                  "_id": "670ee1de9b4ad4c8d8a929b2",
                  "code": "1234",
                  "name": "Salmon",
                  "externalKeys": {
                    "code": "1234Q",
                    "_id": "670ee1de9b4ad4c8d8a929b3"
                  },
                  "company": {
                    "_id": "670ebaa456795645a556a2b5",
                    "id": 1,
                    "name": "EL CORTIJO",
                    "statusId": 1
                  },
                  "baseUnitOfMeasure": {
                    "_id": "66e9fa14aac6881544177225",
                    "code": "456A",
                    "name": "Libras",
                    "statusId": 1,
                    "_deleted": false,
                    "createdAt": "2024-10-15T21:42:54.328Z",
                    "updatedAt": "2024-10-15T21:42:54.328Z"
                  },
                  "price": 5,
                  "UMPActive": true,
                  "materialBrand": {
                    "_id": "67093bff9b4ad4c8d8a9220f",
                    "code": "PL",
                    "name": "Market Cortijo",
                    "statusId": 1
                  },
                  "ltsLbs": 0,
                  "division": {
                    "_id": "66ea523af017017d00d177c0",
                    "id": 3,
                    "name": "Division 10",
                    "statusId": 1
                  },
                  "materialGroups": [
                    {
                      "_id": "670d4ac19b4ad4c8d8a92391",
                      "code": "CL",
                      "name": "Clavos",
                      "statusId": 1
                    }
                  ],
                  "position": 202,
                  "batchControlActive": false,
                  "statusId": 1,
                  "_deleted": false,
                  "alternalUnitOfMeasures": [],
                  "orderDeliveryWindows": [],
                  "createdAt": "2024-10-15T21:42:54.328Z",
                  "updatedAt": "2024-10-16T20:28:29.765Z",
                  "__v": 0,
                  "subtotal": 40,
                  "quantity": 8
                },
                "unitOfMeaure": {
                  "_id": "66e9fa14aac6881544177225",
                  "code": "456A",
                  "name": "Libras"
                },
                "quantity": 8,
                "typeCoverageValue": "coverage value",
                "coverageValue": 2
              }
            ],
            "dateTimeStart": "2024-10-17T22:08:29.306Z",
            "dateTimeEnd": "2024-10-17T22:08:29.306Z"
          },
          "isPromotion": false,
          "hasScalePrices": false,
          "hasMinimumAndMaximunPrices": false,
          "unitPrice": 5,
          "unitPriceOriginal": 5,
          "originalQuantity": 8,
          "conversionFactor": 1,
          "unitOfMeasure": {
            "_id": "66e9fa5faac688154417722f",
            "code": "Kg",
            "name": "Kilogramos"
          },
          "material": {
            "_id": "670ee1de9b4ad4c8d8a929b2",
            "code": "1234",
            "externalKeys": {
              "code": "1234Q",
              "_id": "670ee1de9b4ad4c8d8a929b3"
            },
            "materialGroups": [
              {
                "_id": "670d4ac19b4ad4c8d8a92391",
                "code": "CL",
                "name": "Clavos",
                "statusId": 1,
                "id": 1
              }
            ],
            "name": "Salmon"
          }
        }
      ]
    },
  ],
}

export const materialsListMock = [{
  "_id": "67292089dd2fdc8a85aa4016",
  "externalKeys": {
    "code": "000000000013000021"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    },
    {
      "isUMB": false,
      "isUMP": true,
      "quantity": 1,
      "equivalentQuantity": 2.21,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d2",
        "code": "KG",
        "name": "Kilogramo",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000013000021",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "CARNE MOLIDA ESPECIAL CONGELADO",
  "descriptionShort": "CARNE MOLIDA ESPECIAL CONGELADO",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 0,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "KG",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "CARNE MOLIDA ESPECIAL CONGELADO",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
},
{
  "_id": "67294a5add2fdc8a85f4cc60",
  "externalKeys": {
    "code": "000000000016000000"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000016000000",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "POLLITO DE UN DIA",
  "descriptionShort": "POLLITO DE UN DIA",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 0.08,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "LB",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "POLLITO DE UN DIA",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
},
{
  "_id": "67294a5add2fdc8a85f4cc67",
  "externalKeys": {
    "code": "000000000019000000"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    },
    {
      "isUMB": false,
      "isUMP": true,
      "quantity": 100,
      "equivalentQuantity": 900,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000019000000",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "GALLINA CONG.",
  "descriptionShort": "GALLINA CONG.",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 1,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "LB",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "GALLINA CONG.",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
},
{
  "_id": "67294a5add2fdc8a85f4cc78",
  "externalKeys": {
    "code": "000000000019000001"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    },
    {
      "isUMB": false,
      "isUMP": true,
      "quantity": 100,
      "equivalentQuantity": 950,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000019000001",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "GALLINA CON MENUDO CONG.",
  "descriptionShort": "GALLINA CON MENUDO CONG.",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 1,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "LB",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "GALLINA CON MENUDO CONG.",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
},
{
  "_id": "67294a5add2fdc8a85f4cc7f",
  "externalKeys": {
    "code": "000000000019000003"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    },
    {
      "isUMB": false,
      "isUMP": true,
      "quantity": 1000,
      "equivalentQuantity": 3000,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000019000003",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "POLLO S/M 2.75 - 3.00 LB (AZUL) FRESCO",
  "descriptionShort": "POLLO S/M 2.75 - 3.00 LB (AZUL) FRESCO",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 1,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "LB",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "POLLO S/M 2.75 - 3.00 LB (AZUL) FRESCO",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
},
{
  "_id": "67294a5add2fdc8a85f4cc87",
  "externalKeys": {
    "code": "000000000019000002"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    },
    {
      "isUMB": false,
      "isUMP": true,
      "quantity": 1000,
      "equivalentQuantity": 3000,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000019000002",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "POLLO S/M 2.75 - 3.00 LB (AZUL) CONG.",
  "descriptionShort": "POLLO S/M 2.75 - 3.00 LB (AZUL) CONG.",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 1,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "LB",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "POLLO S/M 2.75 - 3.00 LB (AZUL) CONG.",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
},
{
  "_id": "67294a5add2fdc8a85f4cc95",
  "externalKeys": {
    "code": "000000000019000004"
  },
  "UMPActive": false,
  "_deleted": false,
  "alternalUnitOfMeasures": [
    {
      "isUMB": true,
      "isUMP": false,
      "quantity": 1,
      "equivalentQuantity": 1,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    },
    {
      "isUMB": false,
      "isUMP": true,
      "quantity": 100,
      "equivalentQuantity": 325,
      "conversionFactor": null,
      "barcode": "",
      "price": "",
      "unitOfMeasure": {
        "_id": "6712a15ec12eea7f7850f1d3",
        "code": "LB",
        "name": "Libra (pound)",
        "statusId": 1,
        "_deleted": false
      }
    }
  ],
  "barcode": "",
  "barcodeType": "",
  "baseUnitOfMeasure": {
    "_id": "6712a15ec12eea7f7850f1d3",
    "code": "LB",
    "name": "Libra (pound)",
    "statusId": 1
  },
  "batchControlActive": true,
  "canMakeAnOrderWithoutStock": false,
  "code": "000000000019000004",
  "company": {
    "_id": "670ebaa456795645a556a2b5",
    "id": 1,
    "name": "EL CORTIJO",
    "statusId": 1
  },
  "descriptionLong": "POLLO S/M 3.00 - 3.25 LB (ROJO) CONG.",
  "descriptionShort": "POLLO S/M 3.00 - 3.25 LB (ROJO) CONG.",
  "dimensions": {
    "height": 0,
    "width": 0,
    "length": 0,
    "grossWeight": 1,
    "netWeight": 0,
    "weightUnitOfMeasureCode": "LB",
    "volume": 0,
    "volumeUnitOfMeasureCode": ""
  },
  "division": {
    "_id": "670fdcbf85638800f857f97c",
    "id": 1,
    "name": "DIVISION EL CORTIJO",
    "statusId": 1
  },
  "ltsLbs": 0,
  "materialBrand": [],
  "materialGroups": {
    "_id": "6723f4329d97cb1f19e0bec1",
    "code": "SEMIE001",
    "name": "SEMI-TERMINADOS",
    "statusId": 1
  },
  "name": "POLLO S/M 3.00 - 3.25 LB (ROJO) CONG.",
  "orderDeliveryWindows": [],
  "position": 999999,
  "price": 7.42,
  "statusId": 0,
  "tax": [
    {
      "id": 1,
      "name": "1",
      "percentage": "0",
      "statusId": 1
    }
  ]
}]